<!--
 * @Description: 
 * @Date: 2020-09-27 11:16:02
-->
<template>
  <div class="activity">
    <div class="activity-title">
      <h5>热门活动赢壕礼</h5>
      <p>中奖记录</p>
    </div>
    <ul>
      <li>
        <div class="d1">
          <img src alt />
          <div>
            <h5>大转盘抽奖，等你玩</h5>
            <p>抽奖好运连连，积分无处不在</p>
          </div>
        </div>
        <p class="d2">活动时间：09-22 12:00 至 09-30 12:00</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang='less'>
.activity {
  padding: 0.43rem;
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h5 {
      font-size: 0.43rem;
    }
    p {
      color: #959599;
      font-size: 0.43rem;
    }
  }
  ul {
    margin-top: 0.64rem;
    li {
      height: 2.85rem;
      border-radius: 0.21rem;
      background: linear-gradient(217deg, #a66ef9 0%, #8a61e1 100%);
      padding: 0.32rem;
      margin-bottom: 0.33rem;
      .d1 {
        display: flex;
        align-items: center;
        margin-bottom: 0.53rem;
        img {
          display: block;
          margin-right: 0.32rem;
          width: 1.39rem;
          height: 1.39rem;
        }
        div {
          h5 {
            color: #fff;
            font-size: 0.48rem;
            line-height: 1;
            margin-bottom: 0.32rem;
          }
          p {
            color: rgba(255, 255, 255, 0.8);
            font-size: 0.37rem;
          }
        }
      }
      .d2 {
        font-size: 0.29rem;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
